import React, { useState, useEffect, useRef } from "react";
import { AppProvider, useAppContext } from "@/AppContext";
import { ReactFlowProvider } from "@xyflow/react";
import PageTop from "@/Pages/Project/PageTop";
import PageSeletor from "@/Pages/Project/Flow/Right/PageSeleltor";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Space,
  message,
  Input,
  Collapse,
  Modal,
  Checkbox,
  Typography,
  notification,
} from "antd";
// message.config({ top: 120 });
const { Text } = Typography;
import {
  CloudUploadOutlined,
  SaveOutlined,
  LoadingOutlined,
  WarningOutlined,
  VerticalAlignTopOutlined,
  CheckCircleFilled,
  LeftOutlined
} from "@ant-design/icons";
import userInfo from "@/Components/user";
import { getFlow, saveFlow, simulation } from "@/services/common";
import Diagram from "@/Components/Diagram/Diagram2";
import ParameterEditor from "@/Components/Diagram/ParameterEditor";
import SelectElementsModal, { buildTaskInput } from "@/Components/Diagram/SelectElementsModal";
import {
  buildNodeModal2Data,
  buildNodeModalParams,
  buildLinkModal2Data,
  buildLinkMaterialsData,
  getStreamsBasicParams,
  initializeLocalParamValues,
} from "@/Components/Diagram";
import { typeMap3 } from "@/constants/dataMap";
import emptyJosn from "../../../../Main/empty.json";
import dayjs from "dayjs";

const Component = () => {
  const { state, actions } = useAppContext();
  const [activeTab, setActiveTab] = useState("element");
  const location = useLocation();
  const [messageApi, contextHolder] = message.useMessage();
  const [jsonData, setJsonData] = useState(null);
  const [nodeData, setNodeData] = useState(null);
  const [linkData, setLinkData] = useState(null);
  const [hideNodeData, setHideNodeData] = useState(null);
  const [selectNode, setSelectNode] = useState("");
  const [selectLink, setSelectLink] = useState("");
  const [globalData, setGlobalData] = useState(null);

  const [localFormData, setLocalFormData] = useState<Record<string, any>>({});
  const [modalParams, setModalParams] = useState<any[] | null>(null);
  const [localParamValues, setLocalParamValues] = useState<Record<string, any>>({});
  const [materialsData, setMaterialsData] = useState<any>(null);
  const [localMaterialsData, setLocalMaterialsData] = useState<Record<string, any>>({});
  const prevSelectNode = usePrevious(selectNode);
  const prevSelectLink = usePrevious(selectLink);
  const [taskModalVisible, setTaskModalVisible] = useState(false);
  const [currentJsonDataForTask, setCurrentJsonDataForTask] = useState<any>(null);
  const navigate = useNavigate();
  const [diagrams, setDiagrams] = useState<any>(null);
  const [screenSize, setScreenSize] = useState<number>(100);
  const [selectJson, setSelectJson] = useState<any>(emptyJosn);
  const [loadingVariable, setLoadingVariable] = useState(true);
  const [designVisible, setDesignVisible] = useState(false);
  const [fastVisible, setFastVisible] = useState(false);
  const [loadingTxt, setLoadingTxt] = useState("加载中");
  const saveAbledRef = useRef(false);
  const [activePanel, setActivePanel] = useState<string[] | string | null>(""); //当前参数分类面板

  const [api, notificationContextHolder] = notification.useNotification();
  const NOTICE_KEY = "error-notice";
  const params1 = useParams<{ k: string; f: string; j: string }>();

  // 点击滚动
  const scrollToElementTarget = (cid:string,id: string) => {
    const container = document.getElementById(cid);
    // const container = document.querySelector('.scroll-container');
    
    const targetItem = document.getElementById(id);

    if (container && targetItem) {
      container.scrollTo({
        top: targetItem.offsetTop - 300, 
        behavior: 'smooth',
      });
    }
  };

  const stateParams = useParams<{ k: string; f: string; j: string }>();
  const checkNameUnique = (name: string, type: "node" | "link", excludeKey?: string): boolean => {
    if (type === "node") {
      if (!nodeData) return true;
      return !nodeData.some(
        (node: any) => node.nodeName === name && name !== "" && node.key !== excludeKey,
      );
    } else {
      if (!linkData) return true;
      return !linkData.some(
        (link: any) => link.linkName === name && name !== "" && link.key !== excludeKey,
      );
    }
  };

  useEffect(() => {
    actions.loadData();
    // 执行数据加载逻辑
  }, [location.search]);

  useEffect(() => {
    if (location.state.globalData) {
      setGlobalData(location.state.globalData);
    } else {
      if (state.curFlow) {
        setGlobalData(state.curFlow.global_data);
      }
    }
  }, [location]);

  useEffect(() => {
    if (stateParams) {
      queryCurFlow();
    }
  }, [stateParams]);

  // console.log("stateParams", stateParams);

  // useEffect(() =>
  // {
  //   if(state.curFlow)
  //   {
  //     setGlobalData(state.curFlow.global_data);
  //   }
  // }, [state.curFlow?.id]);

  useEffect(() => 
  {
    if (activeTab === "element") 
    {
      setSelectLink("");
    } 
    else if (activeTab === "stream") 
    {
      setSelectNode("");
    }
  }, [activeTab]);

  useEffect(() => 
  {
    //每次组件更新都会触发本地保存（否则双击图像时无法正确保存）
    if (selectNode || selectLink) 
    {
      saveCurData();
    }
  }, [localParamValues,localFormData,localMaterialsData]);

  // 当选中节点变化时，更新编辑数据
  useEffect(() => {
    // 避免因 nodeData 更新导致重复执行（只响应 selectNode 真实变化）
    if (!selectNode || !nodeData) return;
    if (prevSelectNode === selectNode) return;

    upSelectJson("node", selectNode);

    const currentNode = nodeData.find((item: any) => item.nodeName === selectNode);
    if (!currentNode) return;

    // 构建 modal2Data
    const newModal2Data = buildNodeModal2Data(currentNode);
    setLocalFormData(newModal2Data);

    // 构建 modalParams
    const params = buildNodeModalParams(currentNode);
    if (params.length === 0) {
      setModalParams(null);
      setLocalParamValues({});
      return;
    }
    setModalParams(params);

    // 构建 localParamValues，需要已保存的参数值
    const savedValues = currentNode.ParamValues || {};
    // 对于 Ns/No 需要 linkDataArray
    const initialValues = initializeLocalParamValues(
      params,
      newModal2Data,
      savedValues,
      currentNode.key,
      linkData, // 全量 linkDataArray
      selectNode,
    );
    // debugger
    setLocalParamValues(initialValues);

    // 清空流股相关数据
    setMaterialsData(null);
    setLocalMaterialsData({});
  }, [selectNode, nodeData, linkData, prevSelectNode]);

  // 当选中流股变化时
  useEffect(() => {
    if (!selectLink || !linkData) return;
    if (prevSelectLink === selectLink) return;

    const currentLink = linkData.find((item: any) => item.linkName === selectLink);
    if (!currentLink) return;

    upSelectJson("link", selectLink);

    // 构建 modal2Data
    const newModal2Data = buildLinkModal2Data(currentLink);
    setLocalFormData(newModal2Data);

    // 流股参数
    const params = getStreamsBasicParams();
    setModalParams(params);

    // 构建 localParamValues
    const savedValues = currentLink.ParamValues || {};
    const initialValues = initializeLocalParamValues(params, newModal2Data, savedValues);
    setLocalParamValues(initialValues);

    // 构建 materialsData
    const globalMaterials = globalData?.materials || []; // 根据实际全局数据结构调整
    const newMaterialsData = buildLinkMaterialsData(currentLink, globalMaterials);
    setMaterialsData(newMaterialsData);
    setLocalMaterialsData(newMaterialsData); // 初始时直接赋值
  }, [selectLink, linkData, globalData, prevSelectLink]);

  function usePrevious<T>(value: T): T | undefined {
    const ref = useRef<T>();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  }

  //查询当前流程图
  const queryCurFlow = () => {
    let token = userInfo.access_token;
    const projectId = stateParams.k;
    const flowId = stateParams.f;
    // let flowId = state.curFlow["id"];
    // let projectId = state.curFlow["project_id"];
    getFlow(projectId, flowId, token).then(async (res) => {
      if (res.status === 200) {
        if (res.data.flow_data_url) {
          let flowDataUrl = res.data.flow_data_url;
          let response = await fetch(flowDataUrl);
          let newJsonData = await response.json();
          setJsonData(newJsonData);
          setNodeData(
            newJsonData.nodeDataArray.filter(
              (item: any) => !item.isGroup && item.type !== "comments" && item.nodeName !== "",
            ),
          );
          setLinkData(newJsonData.linkDataArray);
          setHideNodeData(
            newJsonData.nodeDataArray.filter(
              (item: any) => item.isGroup || item.type === "comments" || item.nodeName === "",
            ),
          );
          //默认选第一个
          setSelectNode(
            newJsonData.nodeDataArray.filter((item: any) => !item.isGroup)?.[0]?.nodeName ?? "",
          );
          setLoadingVariable(false);

          // let global_data = res.data.global_data;
          // setGlobalData(global_data);

          // console.log("jsonData", newJsonData);
        } else {
          messageApi.open({
            type: "error",
            content: `查询失败：${res.status}`,
            style: { marginTop: "50px" },
          });
          setLoadingVariable(false);
        }
      } else {
        messageApi.open({
          type: "error",
          content: `查询失败：${res.status}`,
          style: { marginTop: "50px" },
        });
        setLoadingVariable(false);
      }
    });
  };

  const getUpdatedNodeData = () => {
    if (activeTab !== "element" || !selectNode || !nodeData) return nodeData;
    const currentNode = nodeData.find((item: any) => item.nodeName === selectNode);
    if (!currentNode) return nodeData;

    const newName = localFormData["元件名称"]?.value;
    // 名称唯一性校验（如果需要，可在此处校验，或者调用方已校验）
    if (newName && newName !== selectNode && !checkNameUnique(newName, "node", currentNode.key)) {
      return nodeData; // 名称重复，不更新
    }

    const updatedNode = { ...currentNode };
    Object.entries(localFormData).forEach(([_, field]: [string, any]) => {
      if (field.engName) {
        updatedNode[field.engName] = field.value;
        if (field.engName === "nodeName") updatedNode.text = field.value;
      }
    });
    updatedNode.ParamValues = localParamValues;

    return nodeData.map((item: any) => (item.key === currentNode.key ? updatedNode : item));
  };

  // 计算更新后的 linkData
  const getUpdatedLinkData = () => {
    if (activeTab !== "stream" || !selectLink || !linkData) return linkData;
    const currentLink = linkData.find((item: any) => item.linkName === selectLink);
    if (!currentLink) return linkData;

    const newName = localFormData["流股名称"]?.value;
    if (newName && newName !== selectLink && !checkNameUnique(newName, "link", currentLink.key)) {
      return linkData;
    }

    const updatedLink = { ...currentLink };
    Object.entries(localFormData).forEach(([_, field]: [string, any]) => {
      if (field.engName) {
        updatedLink[field.engName] = field.value;
        if (field.engName === "linkName") updatedLink.text = field.value;
      }
    });
    updatedLink.ParamValues = localParamValues;

    if (localMaterialsData && Object.keys(localMaterialsData).length > 0) {
      const newMaterials: any = {};
      Object.entries(localMaterialsData).forEach(([key, value]: [string, any]) => {
        newMaterials[key] = {
          molar_frac: value.molar_frac,
          desValue: value.desValue,
          cas: value.cas,
          name: value.name,
          chineseName: value.chineseName,
        };
      });
      updatedLink.materials = newMaterials;
    }

    return linkData.map((item: any) => (item.key === currentLink.key ? updatedLink : item));
  };

  const saveCurData = () => 
  {
    if(saveAbledRef.current)
    {
      if (activeTab === "element" && selectNode && nodeData) 
      {
        const updatedList = getUpdatedNodeData();
        if (updatedList !== nodeData) 
        {
          setNodeData(updatedList);
          const newName = localFormData["元件名称"]?.value;
          if (newName && newName !== selectNode) 
          {
            setSelectNode(newName);
          }
        }
      } 
      else if (activeTab === "stream" && selectLink && linkData) 
      {
        const updatedList = getUpdatedLinkData();
        if (updatedList !== linkData) {
          setLinkData(updatedList);
          const newName = localFormData["流股名称"]?.value;
          if (newName && newName !== selectLink) {
            setSelectLink(newName);
          }
        }
      }

      return true;
    }
    else 
    {
      return false;
    }
  };

  const saveDiagram = async () => {
    setLoadingTxt("保存中");
    setLoadingVariable(true);
    let isSaveSuccess = saveCurData();
    if(isSaveSuccess)
    {
      const finalVisibleNodes = activeTab === "element" ? getUpdatedNodeData() : nodeData;
      const finalNodeDataArray = [...(finalVisibleNodes || []), ...(hideNodeData || [])];
      const finalLinkData = activeTab === "stream" ? getUpdatedLinkData() : linkData;

      const newJsonData = {
        ...jsonData,
        nodeDataArray: finalNodeDataArray,
        linkDataArray: finalLinkData,
      };
      // console.log("newJsonData:",newJsonData);

      let token = userInfo.access_token;
      let flowId = state.curFlow["id"];
      let projectId = state.curFlow["project_id"];
      return saveFlow(projectId, flowId, newJsonData, token).then(async (res) => {
        if (res.status === 200) {
          messageApi.open({
            type: "success",
            content: "保存成功",
            style: { marginTop: "50px" },
          });
          setLoadingVariable(false);

          return true;
        } else {
          messageApi.open({
            type: "error",
            content: `保存失败：${res.status}`,
            style: { marginTop: "50px" },
          });
          setLoadingVariable(false);

          return false;
        }
      });
    }
    else
    {
      messageApi.open
      ({
        type:"error",
        content:"保存失败：数据非法",
        style: { marginTop: "50px" },
      });
      setLoadingVariable(false);
      return false;
    }
  };

  const exportDiagram = async () => {
    const allItems = (jsonData?.nodeDataArray || []).filter(
      (item: any) => !item.isGroup && item.elementName && item.nodeName.trim() !== "",
    );
    const allItemNames = allItems.map((item: any) => item.nodeName);

    const inputJson = buildTaskInput(jsonData, allItemNames, state);

    let flowName = state.curFlow["name"];
    let inputJsonStr = JSON.stringify(inputJson);
    const blob = new Blob([inputJsonStr], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${flowName}_参数`; // 下载的文件名
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const createTask = async () => {
    api.destroy(NOTICE_KEY);
    const finalVisibleNodes = activeTab === "element" ? getUpdatedNodeData() : nodeData;
    const finalNodeDataArray = [...(finalVisibleNodes || []), ...(hideNodeData || [])];
    const finalLinkData = activeTab === "stream" ? getUpdatedLinkData() : linkData;
    const newJsonData = {
      ...jsonData,
      nodeDataArray: finalNodeDataArray,
      linkDataArray: finalLinkData,
    };
    setCurrentJsonDataForTask(newJsonData);
    setTaskModalVisible(true);
  };

  const onTaskSuccess = async () => {
    const saveSuccess = await saveDiagram();
    if (saveSuccess) {
      const flowId = state.curFlow["id"];
      navigate(`/project/${state.curFlow.project_id}/flow/${flowId}/task`);
    }
  };

  const upSelectJson = (selectType: any, selectName: any) => {
    // console.log("selectName:",selectName);
    // console.log("jsonData:",jsonData);
    // console.log("nodeData:",nodeData);
    // console.log("linkData:",linkData);
    if (selectType === "node") {
      let selectNode = structuredClone(nodeData.find((item) => item.nodeName === selectName) || {});
      let selectNodes = [selectNode];

      let selectLinks = structuredClone(
        linkData.filter((item) => item.from === selectNode?.key || item.to === selectNode?.key) ||
          [],
      );

      //处理连接线对象
      // 左-右+,上-下+
      // 起点与终点存在10偏移量
      for (let i = 0; i < selectLinks.length; i++) {
        let oldPoints = selectLinks[i].points;
        if (oldPoints.length >= 4) {
          let points = [];

          if (selectLinks[i].from === selectNode.key) {
            let fromPort = selectLinks[i].fromPort;
            if (fromPort[0]) {
              points = [oldPoints[0], oldPoints[1], oldPoints[2], oldPoints[3]]; //起点与偏移量不变
              // 计算终点
              if (fromPort[0] === "L") {
                points.push(
                  points[0] - 200, //终点X偏移量
                  points[1], //终点Y偏移量
                  points[0] - 200 - 10, //终点X
                  points[1], //终点Y
                );
              } else if (fromPort[0] === "R") {
                points.push(
                  points[0] + 200, //终点X偏移量
                  points[1], //终点Y偏移量
                  points[0] + 200 + 10, //终点X
                  points[1], //终点Y
                );
              } else if (fromPort[0] === "T") {
                points.push(
                  points[0], //终点X偏移量
                  points[1] - 200, //终点Y偏移量
                  points[0], //终点X
                  points[1] - 200 - 10, //终点Y
                );
              } else if (fromPort[0] === "B") {
                points.push(
                  points[0], //终点X偏移量
                  points[1] + 200, //终点Y偏移量
                  points[0], //终点X
                  points[1] + 200 + 10, //终点Y
                );
              }
            }
          }

          if (selectLinks[i].to === selectNode.key) {
            let toPort = selectLinks[i].toPort;
            if (toPort[0]) {
              // 计算起点
              if (toPort[0] === "L") {
                points.push(
                  oldPoints[oldPoints.length - 2] - 200, //起点X
                  oldPoints[oldPoints.length - 1], //起点Y
                  oldPoints[oldPoints.length - 2] - 200 + 10, //起点X偏移量
                  oldPoints[oldPoints.length - 1], //起点Y偏移量
                );
              } else if (toPort[0] === "R") {
                points.push(
                  oldPoints[oldPoints.length - 2] + 200, //起点X
                  oldPoints[oldPoints.length - 1], //起点Y
                  oldPoints[oldPoints.length - 2] + 200 - 10, //起点X偏移量
                  oldPoints[oldPoints.length - 1], //起点Y偏移量
                );
              } else if (toPort[0] === "T") {
                points.push(
                  oldPoints[oldPoints.length - 2], //起点X
                  oldPoints[oldPoints.length - 1] - 200, //起点Y
                  oldPoints[oldPoints.length - 2], //起点X偏移量
                  oldPoints[oldPoints.length - 1] - 200 + 10, //起点Y偏移量
                );
              } else if (toPort[0] === "B") {
                points.push(
                  oldPoints[oldPoints.length - 2], //起点X
                  oldPoints[oldPoints.length - 1] + 200, //起点Y
                  oldPoints[oldPoints.length - 2], //起点X偏移量
                  oldPoints[oldPoints.length - 1] + 200 - 10, //起点Y偏移量
                );
              }
              points.push(
                oldPoints[oldPoints.length - 4],
                oldPoints[oldPoints.length - 3],
                oldPoints[oldPoints.length - 2],
                oldPoints[oldPoints.length - 1],
              ); //终点与偏移量不变
            }
          }
          selectLinks[i].points = points;
          selectLinks[i].segmentFraction = 0.5; //文字居中
          delete selectLinks[i].segmentIndex;
        }
      }
      const newSelectJson = {
        ...emptyJosn,
        nodeDataArray: selectNodes,
        linkDataArray: selectLinks,
      };
      // console.log("selectJson:", newSelectJson);
      setSelectJson(newSelectJson);
    } else if (selectType === "link") {
      let selectLink = structuredClone(linkData.find((item) => item.linkName === selectName) || {});
      let selectLinks = [selectLink];
      let selectNodes = structuredClone(
        nodeData.filter((item) => item.key === selectLink?.to || item.key === selectLink?.from) ||
          [],
      );

      if (selectNodes.length === 2) {
        //处理元件对象
        let selectFromNode = selectNodes.find((item) => item.key === selectLink.from);
        let selectToNode = selectNodes.find((item) => item.key === selectLink.to);
        let selectFromNodeSizes = selectFromNode.size.split(" ").map(Number); //连接线起点元件尺寸
        let selectToNodeSizes = selectToNode.size.split(" ").map(Number); //连接线终点元件尺寸
        let selectFromNodeLocs = selectFromNode.loc.split(" ").map(Number); //连接线起点元件坐标
        let selectToNodeLocs = selectToNode.loc.split(" ").map(Number); //连接线终点元件坐标
        // selectNode.loc="0 0";
        if (selectFromNode.key !== selectToNode.key) //若起点与终点为同一元件，则无需改动元件位置
        {
          // x坐标
          if (selectToNodeLocs[0] - selectFromNodeLocs[0] > 0) {
            //连接线终点元件位于起点右侧
            selectToNodeLocs[0] =
              selectFromNodeLocs[0] + selectFromNodeSizes[0] / 2 + 100 + selectToNodeSizes[0] / 2;
          } else if (selectToNodeLocs[0] - selectFromNodeLocs[0] < 0) {
            //连接线终点元件位于起点左侧
            selectToNodeLocs[0] =
              selectFromNodeLocs[0] - selectFromNodeSizes[0] / 2 - 100 - selectToNodeSizes[0] / 2;
          }
          // y坐标
          if (selectToNodeLocs[1] - selectFromNodeLocs[1] > 0) {
            //连接线终点元件位于起点下侧
            selectToNodeLocs[1] =
              selectFromNodeLocs[1] + selectFromNodeSizes[1] / 2 + 100 + selectToNodeSizes[1] / 2;
          } else if (selectToNodeLocs[1] - selectFromNodeLocs[1] < 0) {
            //连接线终点元件位于起点上侧
            selectToNodeLocs[1] =
              selectFromNodeLocs[1] - selectFromNodeSizes[1] / 2 - 100 - selectToNodeSizes[1] / 2;
          }
        }
        selectLinks[0].points = [];
        selectLinks[0].segmentFraction = 0.5; //文字居中
        delete selectLinks[0].segmentIndex;
        selectToNode.loc = selectToNodeLocs[0] + " " + selectToNodeLocs[1];
        selectNodes = [selectFromNode, selectToNode];
      }

      const newSelectJson = {
        ...emptyJosn,
        nodeDataArray: selectNodes,
        linkDataArray: selectLinks,
      };
      // console.log("selectJson:", newSelectJson);
      setSelectJson(newSelectJson);
    }
  };

  //默认塔放在首位
  const adjustTower = (arr: any) => {
    // 先判断数组中是否存在 DistilStrict
    if (arr.includes("DistilStrict")) {
      // 过滤出除 DistilStrict 外的所有元素
      const otherItems = arr.filter((item) => item !== "DistilStrict");
      // 把 DistilStrict 放在首位，拼接剩余元素
      return ["DistilStrict", ...otherItems];
    }
    // 不存在则直接返回原数组
    return arr;
  };

  if (globalData) {
    return (
      <ReactFlowProvider>
        {contextHolder}
        {loadingVariable ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(150,170,200,0.3)",
              zIndex: 1000,
              fontSize: 44,
              fontWeight: "bold",
              color: "#1b6ae7",
            }}
          >
            <LoadingOutlined style={{ fontSize: 48, marginRight: 30 }} />
            <span>{loadingTxt}</span>
          </div>
        ) : null}

        {state.curFlow && state.curProject && state.projectList ? (
          <>
            <PageTop
              mainContent={
                <div className="settingSelectorArea">
                  <PageSeletor />
                </div>
              }
            />
            <div className="mainContent">
              <div className="parameterContainer">
                <div className="parameterContent">
                  <div style={{marginBottom:15}}>
                    <Button
                      onClick={() => {
                        //打开页面
                        // 跳转到新的参数查看页面路由（自定义路径，建议和现有格式统一）
                        const projectId = params1.k;
                        const flowId = params1.f;
                        navigate(`/project/${projectId}/flow/${flowId}/design1`);
                      }}
                      style={{color:"#5F5F5F",backgroundColor:"#FFF",border:"1px solid #BBB",borderRadius: "6px"}}
                    >
                      <LeftOutlined />
                      返回流程计算
                    </Button>
                  </div>
                  <div
                    className="parameterTitle"
                    style={{ display: "flex", gap: "8px", marginBottom: "16px" }}
                  >
                    <Button
                      type={activeTab === "element" ? "primary" : "default"}
                      onClick={() => {
                        let isSaveSuccess = saveCurData();
                        if(isSaveSuccess)
                        {
                          setActiveTab("element");
                          setSelectNode(nodeData?.[0]?.nodeName ?? "");
                          setSelectLink("");
                        }
                        else
                        {
                          messageApi.open
                          ({
                            type:"error",
                            content:"保存失败：数据非法",
                            style: { marginTop: "50px" },
                          });
                        }
                      }}
                      style={{ borderRadius: "6px" }}
                    >
                      单元操作
                    </Button>
                    <Button
                      type={activeTab === "stream" ? "primary" : "default"}
                      onClick={() => {
                        let isSaveSuccess = saveCurData();
                        if(isSaveSuccess)
                        {
                          setActiveTab("stream");
                          setSelectLink(linkData?.[0]?.linkName ?? "");
                          setSelectNode("");
                        }
                        else
                        {
                          messageApi.open
                          ({
                            type:"error",
                            content:"保存失败：数据非法",
                            style: { marginTop: "50px" },
                          });
                        }
                      }}
                      style={{ borderRadius: "6px" }}
                    >
                      流股
                    </Button>
                  </div>
                  <div className="parameterTab" style={{ paddingBottom: 30 }}>
                    {activeTab === "element" ? (
                      <>
                        <div
                          className="left-tab"
                          style={{
                            // overflowY: "auto",
                            // overflowX: "hidden",
                            overflow: "hidden",
                            minWidth: 250,
                          }}
                        >
                          {nodeData &&
                            (() => {
                              // 按类型分组
                              const grouped = nodeData.reduce(
                                (acc: Record<string, any[]>, item: any) => {
                                  const type = item.type || "未分类";
                                  if (!acc[type]) acc[type] = [];
                                  acc[type].push(item);
                                  return acc;
                                },
                                {},
                              );
                              // const defaultActiveKeys:any = adjustTower(Object.keys(grouped));
                              const defaultActiveKeys: any = Object.keys(grouped);
                              // console.log('defaultActiveKeys',defaultActiveKeys);
                              return (
                                <>
                                  <Collapse
                                    className="params-collapse"
                                    defaultActiveKey={defaultActiveKeys}
                                    activeKey={activePanel || defaultActiveKeys[0]}
                                    accordion={true}
                                    onChange={(key) => {
                                      setActivePanel(key);
                                      // console.log("key", key);
                                    }}
                                  >
                                    {Object.entries(grouped).map(([type, items]) => {
                                      return (
                                        <Collapse.Panel header={typeMap3[type] || type} key={type}>
                                          <div
                                            style={{
                                              height: `calc(100vh - 305px - ${defaultActiveKeys.length * 46}px)`,
                                              // backgroundColor: "#EEE",
                                              overflowX: "hidden",
                                              overflowY: "auto",
                                            }}
                                            id={type}
                                          >
                                            {(items as any[]).map((item) => (
                                              <div key={item.key} id={`item-${item.nodeName}`}>
                                                <button
                                                  onClick={() => 
                                                  {
                                                    let isSaveSuccess = saveCurData();
                                                    if(isSaveSuccess)
                                                    {
                                                      setSelectNode(item.nodeName);
                                                    }
                                                    else
                                                    {
                                                      messageApi.open
                                                      ({
                                                        type:"error",
                                                        content:"保存失败：数据非法",
                                                        style: { marginTop: "50px" },
                                                      });
                                                    }
                                                  }}
                                                  style={{
                                                    width: "100%",
                                                    height: 35,
                                                    border: "solid #eee",
                                                    cursor: "pointer",
                                                    borderWidth: "0 0 1px 0",
                                                    background:
                                                      selectNode === item.nodeName
                                                        ? "#1b6ae7"
                                                        : "#FFF",
                                                    color:
                                                      selectNode === item.nodeName
                                                        ? "#FFF"
                                                        : "#737373",
                                                    fontSize: 16,
                                                  }}
                                                >
                                                  <div
                                                    style={{
                                                      textAlign: "left",
                                                      padding: "0 20px",
                                                    }}
                                                    
                                                  >
                                                    <span style={{ marginRight: 16 }}>
                                                      {selectNode === item.nodeName ? (
                                                        <CheckCircleFilled />
                                                      ) : (
                                                        <span style={{ color: "#737373" }}>○</span>
                                                      )}
                                                    </span>
                                                    {item.nodeName}
                                                  </div>
                                                </button>
                                              </div>
                                            ))}
                                          </div>
                                        </Collapse.Panel>
                                      );
                                    })}
                                  </Collapse>
                                </>
                              );
                            })()}
                          {/* {nodeData && nodeData.map((item) => (
                            <div>
                              <button
                                onClick={()=>{saveCurData();setSelectNode(item.nodeName);}}
                                style={{width:"100%",height:50,border:"solid #BBB",borderWidth:"0 0 1px 0",background:selectNode===item.nodeName?"#1b6ae7":"#FFF",color:selectNode===item.nodeName?"#FFF":"#5F5F5F",fontSize:16}}
                              >{item.nodeName}</button>
                            </div>
                          ))} */}
                        </div>
                      </>
                    ) : (
                      <>
                        <div
                          className="left-tab"
                          style={{
                            overflowY: "auto",
                            overflowX: "hidden",
                            minWidth: 250,
                            border: "1px solid #eee",
                            padding: "0 20px",
                          }}
                          id="streams-container"
                        >
                          {linkData &&
                            linkData.map((item: any) => (
                              <div key={item.key}>
                                {item.linkName && (
                                  <button
                                   id={`item-${item.linkName}`}
                                    onClick={() => {
                                      let isSaveSuccess = saveCurData();
                                      if(isSaveSuccess)
                                      {
                                        setSelectLink(item.linkName);
                                      }
                                      else
                                      {
                                        messageApi.open
                                        ({
                                          type:"error",
                                          content:"保存失败：数据非法",
                                          style: { marginTop: "50px" },
                                        });
                                      }
                                    }}
                                    style={{
                                      width: "100%",
                                      height: 35,
                                      border: "solid #eee",
                                      cursor: "pointer",
                                      borderWidth: "0 0 1px 0",
                                      background: selectLink === item.linkName ? "#1b6ae7" : "#FFF",
                                      color: selectLink === item.linkName ? "#FFF" : "#737373",
                                      fontSize: 16,
                                    }}
                                  >
                                    <div
                                      style={{
                                        textAlign: "left",
                                        padding: "0 20px",
                                      }}
                                    >
                                      <span style={{ marginRight: 16 }}>
                                        {selectLink === item.linkName ? (
                                          <CheckCircleFilled />
                                        ) : (
                                          <span style={{ color: "#737373" }}>○</span>
                                        )}
                                      </span>
                                      {item.linkName}
                                    </div>
                                  </button>
                                )}
                              </div>
                            ))}
                        </div>
                      </>
                    )}
                    <div
                      className="right-parameter"
                      style={{ margin: 20, marginTop: 0, width: designVisible ? 500 + 100 : 500 }}
                    >
                      <div
                        style={{
                          margin: 10,
                          marginBottom: designVisible ? 5 : 20,
                          fontSize: 20,
                          fontWeight: "bold",
                          color: "#1b6ae7",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        {`${selectNode || selectLink || ""}参数信息`}
                        {/* <div style={{ marginRight: 5 }}>
                          <button
                            onClick={() => {
                              setDesignVisible(!designVisible);
                            }}
                            style={{
                              width: 120,
                              height: 25,
                              border: designVisible ? 0 : "1px solid #BBB",
                              backgroundColor: designVisible ? "#1b6ae7" : "#FFF",
                              marginRight: 20,
                              fontSize: 14,
                              color: designVisible ? "#FFF" : "#737373",
                            }}
                          >
                            {designVisible ? "关闭输入设计值" : "打开输入设计值"}
                          </button>
                          <button
                            onClick={() => {
                              setFastVisible(true);
                            }}
                            style={{
                              width: 80,
                              height: 25,
                              border: "1px solid #BBB",
                              backgroundColor: "#FFF",
                              fontSize: 14,
                              color: "#BBB",
                            }}
                          >
                            快捷输入
                          </button>
                        </div> */}
                      </div>
                      {designVisible ? (
                        <div
                          style={{
                            marginLeft: 10,
                            marginBottom: 10,
                            color: "#9e9e9e",
                            fontSize: 14,
                          }}
                        >
                          <WarningOutlined style={{ marginRight: 5, color: "orange" }} />
                          提示：第一个输入框为计算值，第二个输入框为设计值
                        </div>
                      ) : null}
                      <div
                        style={{
                          overflowY: "auto",
                          overflowX: "hidden",
                          // maxHeight: designVisible ? "calc(100% - 70px)" : "calc(100% - 55px)",
                          maxHeight: designVisible ? "calc(100% - 70px)" : "calc(100% - 102px)",
                        }}
                      >
                        <ParameterEditor
                          localFormData={localFormData}
                          setLocalFormData={setLocalFormData}
                          modalParams={modalParams}
                          localParamValues={localParamValues}
                          setLocalParamValues={setLocalParamValues}
                          materialsData={materialsData}
                          localMaterialsData={localMaterialsData}
                          setLocalMaterialsData={setLocalMaterialsData}
                          globalData={globalData}
                          selectElement={selectNode || selectLink || ""}
                          maxHeight={"100%"}
                          designVisible={designVisible}
                          fastModalVariable={fastVisible}
                          closeFastModal={() => {setFastVisible(false);}}
                          saveAbled={(newSaveAbled) => {saveAbledRef.current = newSaveAbled;}}
                          isShowDescription={false}
                        />
                      </div>
                    </div>
                    <div
                      style={{
                        flex: 1,
                        marginLeft: 20,
                        marginTop: 20,
                        // marginBottom: 40,
                        marginBottom: 87,
                        border: "1px solid #BBB",
                      }}
                    >
                      <Diagram
                        key={selectNode || selectLink || "default"}
                        diagrams={diagrams}
                        settings={{ readonly: true }}
                        setDiagrams={setDiagrams}
                        dataSource={selectJson}
                        onScaleChange={(scalePercent) => setScreenSize(scalePercent)}
                        onSelectNode = {(newActiveTab,newSelectNode,newSelectLink)=>
                          {
                            if(saveAbledRef.current)
                            {
                              setActiveTab(newActiveTab);
                              setSelectNode(newSelectNode);
                              setSelectLink(newSelectLink);
                            }
                            else
                            {
                              messageApi.open
                              ({
                                type:"error",
                                content:"保存失败：数据非法",
                                style: { marginTop: "50px" },
                              });
                            }
                          }}
                      />
                    </div>
                  </div>
                </div>

                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <Space>
                    {/* <Button
                      key={"导出参数"}
                      icon={<VerticalAlignTopOutlined />}
                      style={{ padding: "1rem 3rem", borderRadius: "0.5rem" }}
                      type="primary"
                      size="large"
                      onClick={() => {
                        exportDiagram();
                      }}
                    >
                      导出参数
                    </Button> */}
                    <Button
                      key={"保存流程"}
                      icon={<SaveOutlined />}
                      style={{ padding: "1rem 3rem", borderRadius: "0.5rem" }}
                      type="primary"
                      size="large"
                      onClick={() => {
                        saveDiagram();
                      }}
                    >
                      保存
                    </Button>
                    {/* <Button
                      key={"提交计算"}
                      icon={<CloudUploadOutlined />}
                      style={{ padding: "1rem 3rem", borderRadius: "0.5rem" }}
                      type="primary"
                      size="large"
                      onClick={() => {
                        createTask();
                      }}
                    >
                      创建计算任务
                    </Button> */}
                  </Space>
                </div>
              </div>
            </div>
          </>
        ) : null}
        {notificationContextHolder}
        <SelectElementsModal
          visible={taskModalVisible}
          jsonData={currentJsonDataForTask}
          onClose={() => setTaskModalVisible(false)}
          onSuccess={onTaskSuccess}
          state={state}
          notificationApi={api}
          notificationKey={NOTICE_KEY}
          setActiveTab={setActiveTab}
          saveCurData={saveCurData}
          setSelectNode={setSelectNode}
          setSelectLink={setSelectLink}
          setActivePanel={setActivePanel}
          scrollToElementTarget={scrollToElementTarget}
        />
      </ReactFlowProvider>
    );
  }
};

export default Component;
